import { render } from "./InformacoesEmpresa.vue?vue&type=template&id=6d308dc9"
import script from "./InformacoesEmpresa.vue?vue&type=script&lang=js"
export * from "./InformacoesEmpresa.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__